import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { NgxDnDModule } from '@swimlane/ngx-dnd';
import { QRCodeModule } from 'angular2-qrcode';

import { FxServicesModule } from '../services/fx-services.module';

// block
import { BreadcrumbBlockComponent } from './block/breadcrumb/breadcrumb-block.component';
import { HeaderBlockComponent } from './block/header/header-block.component';
import { TabsBlockComponent } from './block/tabs/tabs-block.component';
import { SearchBlockComponent } from './block/search/search-block.component';
import { ContentBlockComponent } from './block/content/content-block.component';
// component
import { AppletNavMapComponent } from './component/applet-nav-map/applet-nav-map.component';
import { AppletSelectorComponent } from './component/applet-selector/applet-selector.component';
import { AppletSelectorContentComponent } from './component/applet-selector/applet-selector-content.component';
import { OfficeSelectorComponent } from './component/office-selector/office-selector.component';
import { OfficeSelectorContentComponent } from './component/office-selector/office-selector-content.component';
import { UserAvatorComponent } from './component/user-avator/user-avator.component';
import { IconCompatibleComponent } from './component/icon-compatible/icon-compatible.component';
import { TreeViewComponent } from './component/tree-view/tree-view.component';
import { NavMenuComponent } from './component/nav-menu/nav-menu.component';
import { ListViewComponent } from './component/list-view/list-view.component';
import { ListViewThComponent } from './component/list-view/list-view-th.component';
import { ListViewFilterComponent } from './component/list-view/list-view-filter.component';
import { ListViewSortComponent } from './component/list-view/list-view-sort.component';
import { PhotoUploadComponent } from './component/photo-upload/photo-upload.component';
import { QRCodeComponent } from './component/qrcode/qrcode.component';
import { NoticeIconComponent } from './component/notice-icon/notice-icon.component';
import { NoticeListComponent } from './component/notice-icon/notice-list.component';
import { CascaderComponent } from './component/cascader/cascader.component';
import { CascaderOptionComponent } from './component/cascader/cascader-li.component';
import { HeaderNavMenuComponent } from './component/header-nav-menu/header-nav-menu.component';
// pipe
import { DictConvertPipe } from "./pipe/dict-convert.pipe";
import { TextTruncatePipe, TextLengthSetPipe } from "./pipe/text-length-set.pipe";
import { HtmlPipe } from "./pipe/html.pipe";
import { HighlightPipe } from './pipe/highlight.pipe';
// directive
import { NzButtonSizeDirective } from './directive/nz-button-size.directive';
import { DraggableDirective } from './directive/draggable.directive';
import { ImageAutoFixDirective } from './directive/image-auto-fix.directive';
import { ImagePreviewDirective } from './directive/image-preview.directive';
import { OverlayModule } from '@angular/cdk/overlay';
import { NzNoAnimationDirective } from './directive/nz-no-animation.directive';
import { NzConnectedOverlayDirective } from './directive/nz-connected-overlay.directive';


@NgModule({

  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgZorroAntdModule,
    NgxDnDModule,

    OverlayModule,
    QRCodeModule,
    FxServicesModule,
  ],

  declarations: [
    // ./block
    BreadcrumbBlockComponent,
    HeaderBlockComponent,
    TabsBlockComponent,
    SearchBlockComponent,
    ContentBlockComponent,
    // ./compont
    AppletNavMapComponent,
    AppletSelectorComponent, AppletSelectorContentComponent,
    OfficeSelectorComponent, OfficeSelectorContentComponent,
    UserAvatorComponent,
    IconCompatibleComponent,
    TreeViewComponent,
    NavMenuComponent,
    ListViewComponent,
    ListViewThComponent,
    ListViewFilterComponent,
    ListViewSortComponent,
    PhotoUploadComponent,
    QRCodeComponent,
    NoticeIconComponent,
    NoticeListComponent,
    CascaderComponent,
    CascaderOptionComponent,
    HeaderNavMenuComponent,

    // ./directive
    NzButtonSizeDirective,
    DraggableDirective,
    ImageAutoFixDirective,
    ImagePreviewDirective,
    NzNoAnimationDirective,
    NzConnectedOverlayDirective,
    // ./pipe
    DictConvertPipe,
    HtmlPipe,
    TextTruncatePipe, TextLengthSetPipe,
    HighlightPipe
  ],

  exports: [
    // ./block
    BreadcrumbBlockComponent,
    HeaderBlockComponent,
    TabsBlockComponent,
    SearchBlockComponent,
    ContentBlockComponent,
    // ./compont
    AppletNavMapComponent,
    AppletSelectorComponent,
    OfficeSelectorComponent,
    UserAvatorComponent,
    IconCompatibleComponent,
    TreeViewComponent,
    NavMenuComponent,
    ListViewComponent,
    ListViewThComponent,
    ListViewFilterComponent,
    ListViewSortComponent,
    PhotoUploadComponent,
    QRCodeComponent,
    NoticeIconComponent,
    NoticeListComponent,
    CascaderComponent,
    CascaderOptionComponent,
    HeaderNavMenuComponent,

    // ./directive
    NzButtonSizeDirective,
    DraggableDirective,
    ImageAutoFixDirective,
    ImagePreviewDirective,
    NzNoAnimationDirective,
    NzConnectedOverlayDirective,
    // ./pipe
    DictConvertPipe,
    TextTruncatePipe, TextLengthSetPipe,
    HtmlPipe, 
    HighlightPipe
  ]

})
export class FxComponentsModule { }
